<div class="container">
  <span class="searchFile">
    <strong translate>{{ 'request.update.search' | translate }} </strong>
  </span>

  <div>
    <button id="uploadButtonUpdate" type="button" mat-stroked-button color="accent" (click)="fileInput.click()">
      <mat-icon class="file_upload"></mat-icon>
      <span *ngIf="!loadFile" translate>{{ 'request.update.add' | translate }}</span>
      <span *ngIf="loadFile" translate>{{ 'request.update.replace' | translate }}</span>
    </button>
    <input id="fileUpdate" hidden (change)="selectFile($event)" #fileInput type="file" id="file" autocomplete="off" />
    <ng-container *ngIf="fileUpload">
      <mat-icon [ngClass]="validationError ? 'error-icon' : 'primary-icon'">
        {{ iconCircle }}
      </mat-icon>
      <span>{{ nameFile }}</span>
    </ng-container>
  </div>

  <div>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'request.update.description' | translate }}</mat-label>
      <input
        id="getDescriptionButtonUpdate"
        type="text"
        #description
        matInput
        (keyup)="getDescription($event.target.value)"
        maxlength="40"
        autocomplete="off"
      />
      <mat-hint align="end"
        >{{ description.value?.length || 0 }}/40 {{ 'request.update.characteres' | translate }}</mat-hint
      >
    </mat-form-field>
  </div>
</div>
